import React from 'react';
import './Title.css';

class Title extends React.Component {
  constructor(props) {
    super(props);
    this.deleteTitle = this.deleteTitle.bind(this);
    this.onTitleClick = this.onTitleClick.bind(this);
  }

  renderAction() {
      
    return (<button className="Title-action" onClick={this.deleteTitle} >-</button>) ;
  }

  deleteTitle() {
    this.props.onDelete(this.props.id);
  }

  onTitleClick() {
    this.props.onTitleClick(this.props.title, this.props.id) ;
  }

  render() {
   return (
    <div className="Title">
        <div className="Title-information">
            <h3 onClick={this.onTitleClick}>{this.props.title}</h3>
        </div>
     {this.renderAction()}
   </div>)
   }
 }

 export default Title;